import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import {MatPaginator} from '@angular/material/paginator';
import {MatTableDataSource} from '@angular/material/table';
import {LiveAnnouncer} from '@angular/cdk/a11y';
import { MatSort, Sort } from '@angular/material/sort';
import { isNgTemplate } from '@angular/compiler';
interface Item {
  subject ?: string;
  sender?: string;
  date?: string;
  hover?: boolean;


}
const getKeyValue = <U extends keyof T, T extends object>(key: U) => (obj: T) =>
  obj[key]

@Component({
  selector: 'app-table',
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.scss']
})
export class TableComponent implements AfterViewInit,OnInit{
  title = 'angularnew-qms';







  
  public  menuclose(user: any ){
    console.log(user)
  
    }
    public button: HTMLElement;

    constructor(private _liveAnnouncer: LiveAnnouncer) {}

    data: any[] = []; 
    itemsPerPage = 5; // Number of items to display per page
    currentPage = 1; // Current page number
    totalPages = 0; // Total number of pages
  //  displayedData: any[] = []; // Data to display on the current page
  

  
    updateDisplayedData() {
      const startIndex = (this.currentPage - 1) * this.itemsPerPage;
      const endIndex = startIndex + this.itemsPerPage;
      this.filteredDataSource = this.messages.slice(startIndex, endIndex);
    }
  
    previousPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        this.updateDisplayedData();
      }
    }
  
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
        this.updateDisplayedData();
      }
    }
  ngOnInit(): void {
    const data = [
      { name: 'John Doe', age: 25 },
      { name: 'Jane Smith', age: 30 },
      // Add more data rows as needed
    ];
    this.totalPages = Math.ceil(this.messages.length / this.itemsPerPage);
    this.updateDisplayedData();
    this.dataSource3 = new MatTableDataSource(data);
  }

  load(ee :Event) {
  }
  editRow(){


    
  }
  rowHovered: any
  archiveRow(){

  }

  delete(message :any ){
  console.log(message);
    alert("delete");
  }
    displayedColumns: string[] = ['position', 'name', 'weight', 'symbol'];
    dataSource = new MatTableDataSource<PeriodicElement>(ELEMENT_DATA);
    dataSource1 = ELEMENT_DATA;

    @ViewChild(MatPaginator) paginator: MatPaginator ;
    @ViewChild(MatSort) sort: MatSort;

    ngAfterViewInit() {
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
      this.dataSource3.sort = this.sort1;

    }
    clickedRows = new Set<PeriodicElement>();

    messages  :Item[]= [
      { subject: 'Message 1', sender: 'Sender 1', date: '2023-05-18', hover: false },
      { subject: 'Message 2', sender: 'Sender 2', date: '2023-05-17', hover: false },
      { subject: 'Message 3', sender: 'Sender 3', date: '2023-05-16', hover: false },
      { subject: 'Message 4', sender: 'Sender 3', date: '2023-05-16', hover: false },
      { subject: 'Message 5', sender: 'Sender 3', date: '2023-05-16', hover: false },
      { subject: 'Message 6', sender: 'Sender 3', date: '2023-05-16', hover: false },
      { subject: 'Message 7', sender: 'Sender 3', date: '2023-05-16', hover: false },
      { subject: 'Message 8', sender: 'Sender 3', date: '2023-05-16', hover: false },
      { subject: 'Message 9', sender: 'Sender 3', date: '2023-05-16', hover: false }

      // Add more sample messages as needed
    ];
    edit(messages:any){
      
    }

    filteredDataSource: Item[]=this.messages;

    applyFilter2(event: Event) {
    
      const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();
  
      if (filter === '') {
        this.filteredDataSource = this.messages;
      } else {
        this.filteredDataSource = this.messages.filter(item =>
          item.subject?.toLowerCase().includes(filter) ||
          item.date?.toString().includes(filter)
        );
      }
    }


    sortedColumn: string = '';
    sortDirection: string = 'asc';
    sortColumn(column : string) {
      if (column === this.sortedColumn) {
        this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
      } else {
        this.sortedColumn = column;
        this.sortDirection = 'asc';
      }
  
      this.filteredDataSource.sort((a,b) => {
        const key = column as string;


        const valueA = a[key as keyof Item];
        const valueB = b[key as keyof Item];
  
        if (valueA! < valueB!) {
          return this.sortDirection === 'asc' ? -1 : 1;
        } else if (valueA! > valueB!) {
          return this.sortDirection === 'asc' ? 1 : -1;
        } else {
          return 0;
        }
      });
    }
 /** Announce the change in sort state for assistive technology. */
 //announceSortChange(sortState: Sort) {
  announceSortChange(ev:Event) {
  // This example uses English messages. If your application supports
  // multiple language, you would internationalize these strings.
  // Furthermore, you can customize the message to add additional
  // details about the values being sorted.
  
  // if (sortState.direction) {
  //   this._liveAnnouncer.announce(`Sorted ${sortState.direction}ending`);
  // } else {
  //   this._liveAnnouncer.announce('Sorting cleared');
  // }
}

selectedRow: any;

onMouseOver(item: any) {
  // Apply hover effect
}

onMouseOut() {
  // Remove hover effect
}

selectRow(item: any) {
  this.selectedRow = item;
  // Perform actions when a row is selected
}

applyFilter(filterValue: string) {
  filterValue = filterValue.trim(); // Remove whitespace
  filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
  this.dataSource.filter = filterValue;
  this.dataSource3.filter = filterValue.trim().toLowerCase();

}
dataSource3: MatTableDataSource<any>;
displayedColumns3: string[] = ['name', 'age']; // Add more columns as needed

@ViewChild(MatSort) sort1: MatSort;





}


export interface PeriodicElement {
  name: string;
  position: number;
  weight: number;
  symbol: string;
}

const ELEMENT_DATA: PeriodicElement[] = [
  {position: 1, name: 'Hydrogen', weight: 1.0079, symbol: 'H'},
  {position: 2, name: 'Helium', weight: 4.0026, symbol: 'He'},
  {position: 3, name: 'Lithium', weight: 6.941, symbol: 'Li'},
  {position: 4, name: 'Beryllium', weight: 9.0122, symbol: 'Be'},
  {position: 5, name: 'Boron', weight: 10.811, symbol: 'B'},
  {position: 6, name: 'Carbon', weight: 12.0107, symbol: 'C'},
  {position: 7, name: 'Nitrogen', weight: 14.0067, symbol: 'N'},
  {position: 8, name: 'Oxygen', weight: 15.9994, symbol: 'O'},
  {position: 9, name: 'Fluorine', weight: 18.9984, symbol: 'F'},
  {position: 10, name: 'Neon', weight: 20.1797, symbol: 'Ne'},
  {position: 11, name: 'Sodium', weight: 22.9897, symbol: 'Na'},
  {position: 12, name: 'Magnesium', weight: 24.305, symbol: 'Mg'},
  {position: 13, name: 'Aluminum', weight: 26.9815, symbol: 'Al'},
  {position: 14, name: 'Silicon', weight: 28.0855, symbol: 'Si'},
  {position: 15, name: 'Phosphorus', weight: 30.9738, symbol: 'P'},
  {position: 16, name: 'Sulfur', weight: 32.065, symbol: 'S'},
  {position: 17, name: 'Chlorine', weight: 35.453, symbol: 'Cl'},
  {position: 18, name: 'Argon', weight: 39.948, symbol: 'Ar'},
  {position: 19, name: 'Potassium', weight: 39.0983, symbol: 'K'},
  {position: 20, name: 'Calcium', weight: 40.078, symbol: 'Ca'},
];
